import React from "react";
import RGL, { WidthProvider } from "react-grid-layout";
import Paper from '@material-ui/core/Paper';
import Article from "../Inputs/Large/Article";
import Type from "../Inputs/Large/Type";
import OrderNyaAntal from "../Inputs/Large/OrderNyaAntalLarge";
// import OrderNyaAntal from "../Inputs/ExtraLarge/OrderNyaAntal";
import OrderStatus from "../Inputs/ExtraLarge/OrderStatus";
import VärdeOrder from "../Inputs/Large/VärdeOrder";
import CustomScrollbars from 'util/CustomScrollbars';
import DashBoardDatumFilter from '../Inputs/DashBoardDatumFilter'
import DaShBoardHeader from '../Inputs/DaShBoardHeader'
const ReactGridLayout = WidthProvider(RGL);

// Lägg till/Ta bort "static: true" på paper för göra boxarna flyttbara eller statiska
export default class StaticElementsLayout extends React.PureComponent {

  render() {
    return (
      <>
      <DaShBoardHeader/>
      <ReactGridLayout
        className="layout"
        rowHeight={40}
        style={{  width: "98vw" }}
      >
        <Paper style={{ backgroundColor: '#14484D', color: '#fff', overflow: 'hidden' }} key="1" 
        data-grid={{ x: 0, y: 0, w: 8, h: 6, static: true }}>
          <span className="text"><VärdeOrder heightValue={220} Afid={this.props.Afid} Flags={this.props.Flags} Kontor={this.props.Kontor}/></span>
        </Paper>
        <Paper style={{ backgroundColor: '#14484D', color: '#fff', overflow: 'hidden' }} key="2" 
        data-grid={{ x: 8, y: 0, w: 4, h: 6, static: true }}>
          <span className="text"><Type heightValue={210} Afid={this.props.Afid} Flags={this.props.Flags} Kontor={this.props.Kontor}/></span>
        </Paper>
        <Paper style={{ backgroundColor: '#14484D', color: '#fff', overflow: 'hidden' }} key="3" 
        data-grid={{ x: 0, y: 6, w: 4, h: 6, static: true }}>
          <span className="text"><OrderNyaAntal Afid={this.props.Afid} Flags={this.props.Flags} Kontor={this.props.Kontor}/></span>
        </Paper>
        <Paper style={{ backgroundColor: '#14484D', color: '#fff', overflow: 'hidden' }} key="4" 
        data-grid={{ x: 4, y: 6, w: 4, h: 6, static: true }}>
          <span className="text"><OrderStatus heightValue={220} Afid={this.props.Afid} Flags={this.props.Flags} Kontor={this.props.Kontor}/></span>
        </Paper>
        {/*
        <Paper style={{ backgroundColor: '#14484D', color: '#fff', overflow: 'hidden' }} key="10" data-grid={{ x: 0, y: 8.5, w: 8, h: 8.5, static: true }}>
          <span className="text"><AntalArtiklar /></span>
        </Paper>
        */}
        <Paper style={{ backgroundColor: '#14484D', color: '#fff', overflow: 'hidden' }} key="5" 
        data-grid={{ x: 8, y: 6, w: 4, h: 6, static: true }}>
          <span className="text"><Article heightValue={210} Afid={this.props.Afid} Flags={this.props.Flags} Kontor={this.props.Kontor}/></span>
        </Paper>
      </ReactGridLayout>
      
      </>
    );
  }
}